import React from "react";
import Box from "@mui/material/Box";

const iconMap = {
  // skills / interests
  music: "🎶",
  storytelling: "📖",
  games: "🃏",
  arts_crafts: "🎨",
  spiritual: "🙏",
  humor: "😄",
  food: "🍳",
  tech_help: "💻",
  nature: "🌿",
  emotional: "🫂",
  sports: "🏅",
  history: "📜",
  movies_tv: "🎬",
  travel: "✈️",

  church:"⛪",
  garden:"🏡",
  yarn:"🧶",

  // pets
  dog: "🐕",
  cat: "🐈",
  bird: "🐦",
  multiple: "🐾",
  none: "🚫",
};

export default function ChipSelect({
  options,
  mode,
  value,
  onChange,
}) {
  const isSelected = (v) =>
    mode === "single" ? value === v : Array.isArray(value) && value.includes(v);

  const toggle = (v) => {
    if (mode === "single") {
      onChange(value === v ? "" : v);
    } else {
      const curr = Array.isArray(value) ? value : [];
      onChange(curr.includes(v) ? curr.filter((x) => x !== v) : [...curr, v]);
    }
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
      {options?.map((opt) => {
        const sel = isSelected(opt.value);
        return (
          <Box
            key={opt.value}
            component="button"
            type="button"
            onClick={() => toggle(opt.value)}
            aria-pressed={sel}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
              px: "13px",
              py: "6px",
              borderRadius: "999px",
              border: "1.5px solid",
              borderColor: sel ? "var(--main-theme-color)" : "#d1d5db",
              bgcolor: sel ? "var(--main-theme-color)" : "#fff",
              color: sel ? "#fff" : "#374151",
              fontSize: "0.8125rem",
              fontWeight: sel ? 600 : 400,
              lineHeight: 1.35,
              cursor: "pointer",
              transition: "all 0.12s ease",
              outline: "none",
              fontFamily: "inherit",
              whiteSpace: "nowrap",
              "&:hover": {
                borderColor: "var(--main-theme-color)",
                bgcolor: sel ? "var(--main-theme-color)" : "#f3f4f6",
                color: sel ? "#fff" : "var(--main-theme-color)",
                filter: sel ? "brightness(0.88)" : "none",
              },
              "&:focus-visible": {
                outline: `2px solid ${"var(--main-theme-color)"}`,
                outlineOffset: "2px",
              },
            }}
          >
            {opt.icon && (
              <span aria-hidden="true" style={{ fontSize: "0.875rem", lineHeight: 1 }}>
                {iconMap[opt.icon]}
              </span>
            )}
            {opt.label}
          </Box>
        );
      })}
    </Box>
  );
}
